import axios, { baseUrl } from './axios';
import queryString from 'query-string';

export default {
  loadConsultationDetail: async (options = {}) => {
    const result = await axios.get(
      `${baseUrl}/medicare/mob/organisations/${
        options.organisationId
      }/consultation/appointments/${options.appointmentId}`,
    );
    return result.data;
  },
  loadDocumentList: async (options = {}) => {
    const params = queryString.stringify(
      Object.assign(
        { offset: options.offset, limit: options.limit },
        options.filter,
      ),
    );
    const result = await axios.get(
      `${baseUrl}/medicare/mob/organisations/${
        options.organisationId
      }/consultations/${options.consultationId}/documents${
        params ? `?${params}` : ''
      }`,
    );
    return result.data;
  },
};
